import { render, staticRenderFns } from "./OneOnOneService.vue?vue&type=template&id=93b85656&scoped=true"
import script from "./OneOnOneService.vue?vue&type=script&lang=js"
export * from "./OneOnOneService.vue?vue&type=script&lang=js"
import style0 from "./OneOnOneService.vue?vue&type=style&index=0&id=93b85656&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93b85656",
  null
  
)

export default component.exports